import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, query, onValue} from "firebase/database";

const useObtenerClientes = () => {
    
    const [clientes, cambiarClientes] = useState([]);
    

    useEffect(() => {
        //const viajes = [];
        const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/clientes'));
        console.log("consulta base clientes")
        return onValue(consulta, (snapshot) => {
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
            cambiarClientes((clientes) => [...clientes, {...childData, id: childKey}]);
            });
    },{
        onlyOnce: true
      });
    }, []);

    return (clientes);
}


export default useObtenerClientes;